import { ConfigurationStatus, Trial, UpdateStatusEvent } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import Show from "@/components/layouts/Show";
import StatusList from "@/components/lists/status/StatusList";
import { DefaultSortableFields, IStatusListSortable } from "@/components/lists/status/StatusListSort";
import TrialsContext from "@/contexts/data/TrialsContext";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import useTrialStatuses from "@/hooks/data/useTrialStatuses";
import { faExclamationCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle, Box, Button, ListItemIcon, ListItemText, Typography, darken, lighten, styled, useTheme } from "@mui/material";
import { FC, useCallback, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { AppSettings } from '../AppSettings';
import TrialStatusList from "@/components/lists/status/TrialStatusList";



const Trials: FC = () => {
    const theme = useTheme();
    const { data: trials } = useContext(TrialsContext);
    const { idMap: trialStatuses, loading: trialStatusesLoading, validating: trialStatusesValidating, refresh: trialStatusesRefresh } = useTrialStatuses();


    const updateStatuses = useCallback(async (event: UpdateStatusEvent) => {
        await trialStatusesRefresh()
    }, [trialStatusesRefresh]);

    const {processing, queueUpdate, error} = useStatusUpdate(
        updateStatuses,
        updateStatuses
    );

    const queueStatusUpdate = useCallback(async (item: Trial) => {
        await queueUpdate({ trialId: item.id });
        await trialStatusesRefresh();
    }, [queueUpdate, trialStatusesRefresh])

    const loading = trialStatusesLoading;
    const validating = trialStatusesValidating || processing;

    return (
        <>
            <IsLoading name="trials-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Trials
                </Typography>
                <TrialStatusList 
                    data={trials}
                    statuses={trialStatuses}
                    queueUpdate={queueStatusUpdate}
                />
            </Show>
        </>
    )
};

export default Trials;